import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

const mTopMenu = styled.div`
  b {
    font-weight: normal;
    margin: 0 7px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  b:hover {
    cursor: pointer;
  }
  b:first-child {
    margin-left: 0px;
  }
  i:before {
    margin-right: 5px;
  }
`;

const dropdownMenu = styled.ul`
  width: 10rem;

  img {
    max-width: 25px;
    margin-right: 0.5rem;
  }
`;

const Dropdown = styled.div`
  b {
    font-weight: normal;
    margin: 0 7px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  b:hover {
    cursor: pointer;
  }
  b:first-child {
    margin-left: 0px;
  }
  i:before {
    margin-right: 5px;
  }

  &:hover {
    ${dropdownMenu} {
      display: block;
      z-index: 100;
    }
  }
`;

//

const S = {
  mTopMenu,
  dropdownMenu,
  Dropdown,
};

export default S;
